/**
 * `data-pl-anchor` — плавный скролл к якорю.
 *
 * Поддерживает оба варианта:
 *   <a href="#contact" data-pl-anchor>
 *   <a data-pl-anchor="contact">
 *
 * Учитывает sticky header через CSS-переменную `--plp-anchor-offset`
 * (по умолчанию 0).
 */

const INIT_FLAG = 'plAnchorInitialized';

function offset(): number {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--plp-anchor-offset');
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Для старых страниц href — источник истины: правая панель/AI могли обновить
 * его, оставив прежний data-pl-anchor. Если href не является локальным якорем,
 * используем явный enhancer-атрибут (в том числе на <button>).
 */
export function resolveAnchorTarget(el: HTMLElement): string {
  const href = (el.getAttribute('href') ?? '').trim();
  if (href.startsWith('#') && href.length > 1) {
    return href.slice(1);
  }
  return (el.getAttribute('data-pl-anchor') ?? '').trim().replace(/^#/, '');
}

function attach(el: HTMLElement): void {
  if (el.dataset[INIT_FLAG]) return;
  el.dataset[INIT_FLAG] = '1';
  el.addEventListener('click', (e) => {
    const targetId = resolveAnchorTarget(el);
    if (!targetId) return;
    const node = document.getElementById(targetId);
    if (!node) return;
    e.preventDefault();
    const top = node.getBoundingClientRect().top + window.scrollY - offset();
    window.scrollTo({ top, behavior: 'smooth' });
  });
}

export function initAnchor(nodes: NodeListOf<Element> | Element[]): void {
  for (const node of Array.from(nodes)) {
    if (node instanceof HTMLElement) attach(node);
  }
}
